import { render, staticRenderFns } from "./ProductsIntroTable.vue?vue&type=template&id=551352ec&scoped=true&"
import script from "./ProductsIntroTable.vue?vue&type=script&lang=js&"
export * from "./ProductsIntroTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductsIntroTable.vue?vue&type=style&index=0&id=551352ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551352ec",
  null
  
)

export default component.exports